import api from "./axios";
import log from "../utils/log";

export const getEmailDetail = async () => {
  try {
    const response = await api.get("/api/v1/customer/users/emaildetail");
    return response.data;
  } catch (error) {
    log.error(error.response?.data?.message);
  }
};

export const updateEmail = async (userDetails) => {
  try {
    const response = await api.post("/api/v1/customer/users/updateemail", userDetails);
    return response.data;
  } catch (error) {
    log.error(error.response?.data?.message);
    throw error.response?.data || "Something went wrong. Please try again."
  }
};

export const getNameDetails = async () => {
  try {
    const response = await api.get("/api/v1/customer/users/namedetails");
    return response.data;
  } catch (error) {
    log.error(error.response?.data);
  }
};

export const updateNameDetails = async (userDetails) => {
  try {
    const response = await api.put("/api/v1/customer/users/namedetails", userDetails);
    return response.data;
  } catch (error) {
    log.error(error.response?.data?.message);
  }
};

export const getUserGender = async () => {
  try {
    const response = await api.get("/api/v1/customer/users/gender");
    return response.data;
  } catch (error) {
    log.error(error.response?.data?.message);
  }
};

export const updateUserGender = async (userDetails) => {
  try {
    const response = await api.put("/api/v1/customer/users/gender", userDetails);
    return response.data;
  } catch (error) {
    log.error(error.response?.data?.message);
  }
};

export const getCountryOptions = async () => {
  try {
    const response = await api.get("/api/v1/customer/users/location-options");
    return response.data;
  } catch (error) {
    console.error(error.response?.data?.message);
    ;
  }
};

export const getUserLocations = async () => {
  try {
    const response = await api.get("/api/v1/customer/users/locations");
    return response.data;
  } catch (error) {
    log.error(error.response?.data?.message);
  }
};
export const updateStatusAgain = async () => {
  try {
    const response = await api.put("/api/v1/customer/users/updatestatusagain");
    return response.data;
  } catch (error) {
    log.error(error.response?.data?.message);
  }
}

export const getUserAccountDetails = async () => {
  try {
    const response = await api.get("/api/v1/customer/setting/namedetails");
    return response.data;
  } catch (error) {
    log.error(error.response?.data?.message);
  }
}
export const updateUserAccountDetails = async (data) => {
  try {
    const response = await api.put("/api/v1/customer/setting/namedetails", data);
    return response.data;
  } catch (error) {
    log.error(error.response?.data?.message);
  }
}
export const updateAccountEmail = async (data) => {
  try {
    const response = await api.post("/api/v1/customer/setting/request-email-update", data);
    return response.data;
  } catch (error) {
    log.error(error.response?.data?.message);
    const message =
      error.response?.data?.message || "Error fetching payment methods.";
    throw {
      ...error,
      message,
    };
  }
}

export const getUserMedia = async (formData) => {
  try {
    const response = await api.get("/api/v1/customer/users/media", formData);
    return response.data;
  } catch (error) {
    log.error(error.response?.data?.message);
  }
};

export const updateUserMedia = async (formData) => {
  try {
    const response = await api.post("/api/v1/customer/users/media", formData);
    return response.data;
  } catch (error) {
    log.error(error.response?.data?.message);
  }
};

export const getUserStudies = async () => {
  try {
    const response = await api.get("/api/v1/customer/users/studies");
    return response.data;
  } catch (error) {
    log.error(error.response?.data?.message);
  }
}

export const UpdateUserStudies = async (data) => {
  try {
    const response = await api.post("/api/v1/customer/users/studies", data);
    return response.data;
  } catch (error) {
    log.error(error.response?.data?.message);
  }
}

export const getUserGrowths = async () => {
  try {
    const response = await api.get("/api/v1/customer/users/growths");
    return response.data;
  } catch (error) {
    log.error(error.response?.data?.message);
  }
}

export const UpdateUserGrowths = async (data) => {
  try {
    const response = await api.post("/api/v1/customer/users/growths", data);
    return response.data;
  } catch (error) {
    log.error(error.response?.data?.message);
  }
}

export const getUserJobs = async () => {
  try {
    const response = await api.get("/api/v1/customer/users/jobs");
    return response.data;
  } catch (error) {
    console.error(
      error.response?.data?.message || "Error fetching growths."
    );
  }
};

export const updateUserJobs = async (data) => {
  try {
    const response = await api.post("/api/v1/customer/users/jobs", data);
    return response.data;
  } catch (error) {
    console.error(
      error.response?.data?.message || "Error fetching growths."
    );
  }
};

export const updateUserContact = async (data) => {
  try {
    const response = await api.post("/api/v1/customer/users/contact", data);
    return response.data;
  } catch (error) {
    log.error(error.response?.data?.message);
  }
}

export const getMatchSkipped = async (id) => {
  try {
    const response = await api.get(`/api/v1/customer/matches/check-skipped/${id}`);
    return response.data;
  } catch (error) {
    log.error(error.response?.data?.message);
  }
}

export const getMatchLike = async (id) => {
  try {
    const response = await api.get(`/api/v1/customer/matches/check-liked/${id}`);
    return response.data;
  } catch (error) {
    log.error(error.response?.data?.message);
  }
}

export const getEmailDetails = async () => {
  try {
    const response = await api.get(`/api/v1/customer/user/email`);
    return response.data;
  } catch (error) {
    log.error(error.response?.data?.message);
  }
}

export const getReceivesData = async (path, page) => {
  try {
    const response = await api.get(`/api/v1/customer/matches/likes/${path}?page=${page}`);
    return response.data;
  } catch (error) {
    log.error(error.response?.data?.message);
  }
}

export const UpdateKidsFamily = async (data) => {
  try {
    const response = await api.post("/api/v1/customer/users/update-have-kids", data);
    return response.data;
  } catch (error) {
    console.error(
      error.response?.data?.message || "Error fetching growths."
    );
  }
};

export const UpdateWantKids = async (data) => {
  try {
    const response = await api.post("/api/v1/customer/users/update-want-kids", data);
    return response.data;
  } catch (error) {
    console.error(
      error.response?.data?.message || "Error fetching growths."
    );
  }
};

export const getKidsFamily = async () => {
  try {
    const response = await api.get("/api/v1/customer/users/kids-family");
    return response.data;
  } catch (error) {
    console.error(
      error.response?.data?.message || "Error fetching growths."
    );
  }
};

// Personality related actions
export const getPersonalityOptions = async () => {
  try {
    const response = await api.get("/api/v1/customer/users/personality-options");
    return response.data;
  } catch (error) {
    log.error(error.response?.data?.message || "Error fetching personality options.");
    throw error;
  }
};

export const getSelectedPersonalities = async () => {
  try {
    const response = await api.get("/api/v1/customer/users/personalities");
    return response.data;
  } catch (error) {
    log.error(error.response?.data?.message || "Error fetching selected personalities.");
    throw error;
  }
};

export const updatePersonalities = async (personalities) => {
  try {
    const response = await api.post("/api/v1/customer/users/personality", {
      personalities: personalities.map(p => p.id)
    });
    return response.data;
  } catch (error) {
    log.error(error.response?.data?.message || "Error updating personalities.");
    throw error;
  }
};